import {required} from 'vuelidate/lib/validators'
import { mapGetters, mapMutations} from 'vuex';

export default {
    props: ['popupType', 'selectedItem'],
    data() {
        return {
            form: {
                title: '',
                sell_price: 0,
            },
        }
    },

    validations: {
        form: {
            title: {
                required
            },
            sell_price: {
                required
            },
        }
    },
    computed: {
        ...mapGetters({
            priceCategory:'catalog/priceCategory', 
        }),
    },
    watch:{
        priceCategory(e){
            if(e){
                this.form.title = e.title;
                this.form.sell_price = e.sell_price
            }
        }
    }, 
    methods: { 
        closePopup() {
            this.$emit('closePopup')
        },
        sendPriceCategory() {
            if(this.priceCategory){
                const payload = {
                    id: this.priceCategory.id,
                    data:this.form
                }
                this.$emit('changePriceCategory', payload)
            }else{
                this.$emit('sendPriceCategory', this.form)
            }
        },
        ...mapMutations({
            changePriceCategory: 'catalog/changePriceCategory'
        }),
    },
    destroyed() {
        this.changePriceCategory(null);
    }
}